
    <ngx-loading-bar color="#00b1e6"></ngx-loading-bar>
    <router-outlet></router-outlet>
  